import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

export function Layout() {
  const { pathname, hash } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    const pathnameChanged = prevPathname.current !== pathname;
    prevPathname.current = pathname;

    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        // Route change → jump instantly (the View Transitions cross-fade
        // already covers the perceived motion). Same-page anchor click →
        // honour native smooth scroll so the user sees the page glide.
        el.scrollIntoView({
          behavior: pathnameChanged ? ('instant' as ScrollBehavior) : 'smooth',
          block: 'start',
        });
        return;
      }
    }

    if (pathnameChanged) {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
    }
  }, [pathname, hash]);

  return (
    <>
      <Header />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
